"use client";
import React from 'react';
import { useLocation } from './useLocation.js';

function parseSearch(search) {
    const urlSearchParams = new URLSearchParams(search);
    // @ts-ignore
    return Object.fromEntries(urlSearchParams.entries());
}
/**
 * React hook for query params
 *
 * @example
 * ```javascript
 * const [params, setParams] = useQueryParams()
 * ```
 */
function useQueryParams() {
    const { replace, search } = useLocation();
    const [params, setParams] = React.useState(parseSearch(search));
    const set = (params) => {
        // @ts-ignore
        const stringParams = new URLSearchParams(params).toString();
        replace(`?${stringParams}`);
    };
    React.useEffect(() => {
        setParams(parseSearch(search));
    }, [search]);
    return [params, set];
}

export { useQueryParams };
//# sourceMappingURL=useQueryParams.js.map
